export const DASHBOARDS_LOAD = 'DASHBOARDS_LOAD';
export const DASHBOARDS_LOAD_SUCCESS = 'DASHBOARDS_LOAD_SUCCESS';
export const DASHBOARDS_LOAD_ERROR = 'DASHBOARDS_LOAD_ERROR';

export const DASHBOARDS_ADD = 'DASHBOARDS_ADD';
export const DASHBOARDS_ADD_SUCCESS = 'DASHBOARDS_ADD_SUCCESS';
export const DASHBOARDS_ADD_ERROR = 'DASHBOARDS_ADD_ERROR';

export const DASHBOARD_UPDATE = 'DASHBOARD_UPDATE';
export const DASHBOARDS_UPDATE = 'DASHBOARDS_UPDATE';
export const DASHBOARD_UPDATE_SUCCESS = 'DASHBOARD_UPDATE_SUCCESS';
export const DASHBOARDS_UPDATE_SUCCESS = 'DASHBOARDS_UPDATE_SUCCESS';
export const DASHBOARDS_UPDATE_ERROR = 'DASHBOARDS_UPDATE_ERROR';

export const DASHBOARD_DELETE = 'DASHBOARD_DELETE';
export const DASHBOARDS_DELETE = 'DASHBOARDS_DELETE';
export const DASHBOARD_DELETE_SUCCESS = 'DASHBOARD_DELETE_SUCCESS';
export const DASHBOARDS_DELETE_SUCCESS = 'DASHBOARDS_DELETE_SUCCESS';
export const DASHBOARD_DELETE_ERROR = 'DASHBOARD_DELETE_ERROR';
export const DASHBOARDS_DELETE_ERROR = 'DASHBOARDS_DELETE_ERROR';